import { IconTooltip } from '../ui/tooltip';
import { cn } from '../ui/utils';
import { ProviderIcon } from './ProviderIcon';
import { providerName } from './requestMeta';

interface RequestSourceBadgeProps {
  // The request provider name (e.g. "nextrequest"): picks the logo and the tooltip.
  provider?: string;
  className?: string;
}

// Small icon marking a Case that was synced from an external request service
// (NextRequest, ...): the provider's logo, its name in the tooltip.
export function RequestSourceBadge({ provider, className }: RequestSourceBadgeProps) {
  const name = providerName(provider);
  const label = name ? `Synced from ${name}` : 'Synced from an external request';
  return (
    <IconTooltip label={label}>
      <span
        data-testid="request-source"
        role="img"
        aria-label={label}
        className={cn(
          'inline-flex h-6 w-6 items-center justify-center rounded-sm bg-primary/10 text-primary',
          className,
        )}
      >
        <ProviderIcon provider={provider} />
      </span>
    </IconTooltip>
  );
}
